import {REP_SCH} from '../Data/typeDirs'
import GenericSchema from './genericSchema'
// import typeMap from '../Data/typeMap'
// console.log('rep schema', REP_SCH, typeMap)
// console.log('GENERIC SCHEMA', GenericSchema)
// const GenericSchema = typeMap[REP_SCH]
class ReportSchema extends GenericSchema {

  constructor(p){
    super(p)
    this.typeDir = ReportSchema.getTypeDir()
  }

  static getTypeDir(){
    return REP_SCH
  }

  static getExt(){
    return 'schema.json'
  }

  getSchema(){
    return super.getSchema(REP_SCH)
  }

}

if( typeof window !== 'undefined') window._ms_ReportSchema = ReportSchema

export default ReportSchema
